require('@yandex-int/rum-counter/dist/inline/interface');
require('@yandex-int/rum-counter/dist/inline/longtask');

Ya.Rum.init(
    {
        beacon: true,
        clck: 'https://yandex.ru/clck/click',
        reqid: String(Date.now()) + String(Math.random()),
    },
    {
        rum_id: 'ru.dialogs.console',
    },
);
require('@yandex-int/rum-counter/dist/bundle/send');
require('@yandex-int/rum-counter/dist/bundle/implementation');
require('@yandex-int/error-counter/dist/interfaceOverRum');
require('@yandex-int/error-counter/dist/implementation');
require('@yandex-int/error-counter/dist/filters');
require('@yandex-int/error-counter/dist/traceUnhandledRejection');

Ya.Rum.initErrors({ project: 'paskills-dev-console' });
